<template>
  <div>
    <!-- Existing document (URL) shown above upload area when editable -->
    <div v-if="isUrl && !disabled" class="uploaded-file mb-2">
      <CCard>
        <CCardBody class="py-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <CIcon name="cipDoc" size="lg" class="mr-2 text-primary" />
            <a :href="document" target="_blank" class="text-primary">
              <translate translate-context="vatDataForm.document">Current document</translate>
            </a>
          </div>
        </CCardBody>
      </CCard>
    </div>

    <!-- Upload area: show when no document, or when existing URL and editable (to allow replacement) -->
    <div v-if="!document || (isUrl && !disabled)" class="custom-file-upload">
      <input
        type="file"
        ref="fileInput"
        @change="handleFileChange"
        accept=".pdf,.zip"
        class="d-none"
      />
      <div
        class="upload-area text-center py-4"
        @click="$refs.fileInput.click()"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
        :class="{ 'drag-over': isDragging }"
      >
        <CIcon name="cipUpload02" size="custom-size" :height="36" class="text-primary mb-2 d-block mx-auto" />
        <div>
          <translate translate-context="vatDataForm.document">Drag file here or</translate>
          <span class="text-primary font-weight-medium ml-1">
            <translate translate-context="vatDataForm.document">click to upload</translate>
          </span>
        </div>
        <small class="text-muted">
          <translate translate-context="vatDataForm.document">(max 10MB)</translate>
        </small>
      </div>
    </div>

    <!-- Read-only: existing URL document -->
    <div v-else-if="isUrl && disabled" class="uploaded-file">
      <CCard>
        <CCardBody class="py-3 d-flex align-items-center">
          <CIcon name="cipDoc" size="lg" class="mr-2 text-primary" />
          <a :href="document" target="_blank" class="text-primary">
            <translate translate-context="vatDataForm.document">View document</translate>
          </a>
        </CCardBody>
      </CCard>
    </div>

    <!-- New file uploaded -->
    <div v-else-if="document && !isUrl" class="uploaded-file">
      <CCard>
        <CCardBody class="py-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <CIcon name="cipDoc" size="lg" class="mr-2 text-primary" />
            <span>{{ document.name }}</span>
          </div>
          <CButtonClose @click="$emit('remove')" />
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VatDataFormUpload',
  props: {
    document: {
      type: [File, Object, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isUrl() {
      return typeof this.document === 'string'
    }
  },
  data() {
    return {
      isDragging: false
    }
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0]
      this.processFile(file)
    },
    onDragOver() {
      this.isDragging = true
    },
    onDragLeave() {
      this.isDragging = false
    },
    onDrop(event) {
      this.isDragging = false
      const file = event.dataTransfer.files[0]
      this.processFile(file)
    },
    processFile(file) {
      if (!file) return

      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.notifyError(this.$pgettext('vatDataForm.document', 'File cannot exceed 10MB'))
        return
      }

      const allowedTypes = ['application/pdf', 'application/zip', 'application/x-zip-compressed']
      if (!allowedTypes.includes(file.type)) {
        this.notifyError(this.$pgettext('vatDataForm.document', 'Only PDF and ZIP files are accepted'))
        return
      }

      this.$emit('file', file)
    }
  }
}
</script>
